import { render, staticRenderFns } from "./CompetitionDetail.vue?vue&type=template&id=6b4a6132&scoped=true&"
import script from "./CompetitionDetail.vue?vue&type=script&lang=js&"
export * from "./CompetitionDetail.vue?vue&type=script&lang=js&"
import style1 from "./CompetitionDetail.vue?vue&type=style&index=1&id=6b4a6132&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a6132",
  null
  
)

export default component.exports